<div class="h-[92vh] p-8 relative overflow-hidden 3xl:p-12">
  <p theme border-b class="text-2xl font-bold border-b-[4px] pb-2">
    <span>Edit Event</span>
    <mat-icon mat-icon-button mat-dialog-close
      class="cursor-pointer absolute right-6 top-6 text-gray-400">close</mat-icon>
  </p>
  <div class="flex w-full h-full py-6">
    <section class="flex-[5] flex flex-col gap-0 h-full pr-6 overflow-y-auto w-full">
      <ig-tab-image-link-file-selector #imgUploader [compressWidth]="1800" (onImageUploaded)="onImageUploaded($event)"
        [useUploadButton]="false" [initialImg]="event?.cover?.source"></ig-tab-image-link-file-selector>
      <ig-field [control]="form.get('name')" label="Title" icon="title" cls="w-full" class="block mt-3"></ig-field>
      <ig-field [control]="form.get('host')" label="Event Host" icon="title" cls="w-full"></ig-field>
      <ig-field [control]="form.get('venue')" label="Location / Venue Name" icon="room" cls="w-full"></ig-field>
      <ig-address-input [control]="form.get('address')" cls="w-full" class="block mobile:mb-6"
        [label]="addressInputLabel" matTooltip="please type and select an address from the dropdown"></ig-address-input>
      <p *ngIf="!event.isOnlineEvent&&(!event.address?.lat||!event.address?.lng)" class="text-red-500 text-sm text-left !my-1">The
        address for this event may not be accurate, or it is not a recognized Google Maps
        address. Please edit it and select from the dropdown; otherwise, the event will not be
        displayed in Map View</p>
      <div class="flex gap-4 mb-1 w-full">
        <mat-checkbox *ngIf="frontendSettings.customSettings.isAllowOnlineEvents" class="text-gray-400"
          (change)="onlineEventChange($event)" [checked]="!!form.get('isOnlineEvent').value"
          matTooltip="Virtual events (online events) don't have physical addresses">
          Virtual Event
        </mat-checkbox>
        <mat-icon class="mt-[7px] -ml-2.5 !text-gray-400 !w-5 !h-5 !text-base" *ngIf="frontendSettings.customSettings.isAllowOnlineEvents"
          matTooltip="Virtual events don't have physical addresses">info</mat-icon>

        <mat-checkbox (change)="hybridChange($event)"
          [checked]="!!form.get('isHybridEvent').value" matTooltip="Hybrid events are both virtual and in-person">Hybrid
          Event
        </mat-checkbox>
        <mat-icon class="mt-[7px] -ml-2.5 !text-gray-400 !w-5 !h-5 !text-base" matTooltip="Hybrid events are both virtual and in-person">info</mat-icon>
      </div>
      <ig-field [control]="form.get('organizerEmail')" label="Organizer Email" icon="email" cls="w-full"></ig-field>
      <ig-field [control]="form.get('eventLink')" label="Event URL for more information (if applicable)" icon="link"
        cls="w-full"></ig-field>
      <ig-field [control]="form.get('hostLink')" label="Event Host Website URL" icon="room" cls="w-full"></ig-field>
      <ig-field [control]="form.get('ticketUri')" label="Get Tickets URL (if applicable)" icon="room"
        cls="w-full"></ig-field>
      <mat-checkbox class="!block text-gray-500 -translate-y-5" [checked]="!!form.get('isHideTicketUrl').value" (change)="form.get('isHideTicketUrl').setValue($event.checked)">
        Hide Ticket URL
      </mat-checkbox>

      <ig-rich-text-box #richTextBox class="-translate-y-3" [description]="form.get('description').value" 
        (descriptionChange)="onDescriptionChange($event)">
      </ig-rich-text-box>
      <ig-ai-description-generator class="-translate-y-2 mb-4 block" [hubName]="hubName" [item]="event" 
        (onDescriptionSelected)="onAIGeneratedDescriptionSelected($event)">
      </ig-ai-description-generator>


      <div *ngIf="frontendSettings">
        <ig-multi-date-time-picker [controls]="form.get('timeRanges')" 
          [timezoneFormatter]="frontendSettings.customSettings.timezoneFormatter">
        </ig-multi-date-time-picker>
        <div class="text-gray-500 text-xs relative -top-4">
          {{ tzNameByFormatter }}
        </div>
      </div>

      <!-- <div class="flex w-full">
        @if (event.isManuallyCreated) {
        <div style="flex: 1">
          <div class="flex">
            <ig-address-input [control]="form.get('timezone')" cls="w-full" class="block mobile:mb-6"
              label="Enter a city to change timezone" matTooltip="Enter a city to change timezone"
              [hint]="''"></ig-address-input>
            <mat-icon matTooltip="You can only change the timezone of manually created events"
              class="not-change-tip">info
            </mat-icon>
          </div>
        </div>
        }
        
      </div> -->

      <mat-checkbox *ngIf="event?.isForHub" class="!block text-gray-500 -translate-y-3"
        (change)="setAsApprovedChange($event)">
        Set as Approved
      </mat-checkbox>

      <ig-button theme class="block mb-2" [isAsync]="true" [disabled]="!form.valid" (trigger)="saveChanges($event)">Save
        Changes</ig-button>

      <section class="hidden mt-4 flex flex-col gap-3">
        <div class="rounded-xl bg-[#e9f7e8] w-full p-6 text-sm flex flex-col gap-3 relative border"
          [class.bg-white]="editing.basic" [class.border-gray-400]="editing.basic">
          <div *ngIf="!editing.basic" (click)="edit('basic')"
            class="absolute right-6 top-6 flex items-center gap-0 text-gray-500 bg-white rounded-[3px] px-2 py-0.5 border border-gray-300 cursor-pointer">
            <mat-icon class="cursor-pointer !text-base !h-4 !w-5 !leading-4">edit</mat-icon>
            <span>Edit</span>
          </div>
          <div *ngIf="editing.basic" (click)="editing.basic = false"
            class="absolute right-6 top-6 flex items-center gap-0 text-gray-500 bg-white rounded-[3px] px-2 py-0.5 border border-gray-300 cursor-pointer">
            <mat-icon class="cursor-pointer !text-base !h-4 !w-5 !leading-4">close</mat-icon>
            <span>Cancel</span>
          </div>

          <p class="text-lg font-bold text-gray-600 !mb-3">Basic Information</p>
          <div *ngIf="!editing.basic" class="flex flex-col gap-3">
            <div>
              <p class="text-gray-400 text-[13px]">Name</p>
              <p class="font-semibold text-gray-500">{{event?.name}}</p>
            </div>
            <div>
              <p class="text-gray-400 text-[13px]">Date & Time</p>
              <p class="font-semibold text-gray-500">{{event?.startTime}}</p>
            </div>
            <div>
              <p class="text-gray-400 text-[13px]">Address</p>
              <p class="font-semibold text-gray-500">{{event?.address?.address}}</p>
            </div>
          </div>
          <div *ngIf="editing.basic" class="flex flex-col gap-0">
            <ig-field [control]="form.get('name')" label="Title" icon="title" cls="w-full"></ig-field>
            <ig-field [control]="form.get('startTime')" label="Date & Time" icon="schedule" cls="w-full"></ig-field>
            <ig-field [control]="form.get('address')" label="Address" icon="room" cls="w-full"></ig-field>
            <ig-button>Save Changes</ig-button>
          </div>
        </div>
        <div class="rounded-xl bg-[#e7f6fb] w-full p-6 text-sm flex flex-col gap-3 relative">
          <div
            class="absolute right-6 top-6 flex items-center gap-0 text-gray-500 bg-white rounded-[3px] px-2 py-0.5 border border-gray-300 cursor-pointer">
            <mat-icon class="cursor-pointer !text-base !h-4 !w-5 !leading-4">edit</mat-icon>
            <span>Edit</span>
          </div>
          <p class="text-lg font-bold text-gray-600 !mb-3">Host Information</p>
          <div>
            <p class="text-gray-400 text-[13px]">Host</p>
            <p class="font-semibold text-gray-500">{{event?.owner?.name}}</p>
          </div>
          <div>
            <p class="text-gray-400 text-[13px]">Host Email</p>
            <p class="font-semibold text-gray-500">{{event?.organizerEmail}}</p>
          </div>
          <div>
            <p class="text-gray-400 text-[13px]">Host Website</p>
            <p class="font-semibold text-gray-500">{{event?.hostLink}}</p>
          </div>
        </div>
        <div class="rounded-xl bg-[#fef5e6] w-full p-6 text-sm flex flex-col gap-3 relative">
          <div
            class="absolute right-6 top-6 flex items-center gap-0 text-gray-500 bg-white rounded-[3px] px-2 py-0.5 border border-gray-300 cursor-pointer">
            <mat-icon class="cursor-pointer !text-base !h-4 !w-5 !leading-4">edit</mat-icon>
            <span>Edit</span>
          </div>
          <p class="text-lg font-bold text-gray-600 !mb-3">Ticket Information</p>
          <div *ngFor="let ticket of event?.ticketInfo; let i = index">
            <p class="text-gray-400 text-[13px]">Ticket URL {{i + 1}}</p>
            <p class="font-semibold text-gray-500">{{ticket?.link}}</p>
          </div>
        </div>
      </section>
    </section>

    <section class="hidden flex-[2] flex flex-col gap-4 pl-6 overflow-y-auto">
      <div class="rounded-xl bg-orange-100 aspect-square w-full flex flex-col justify-between">
        <div class="text-gray-600 p-6 relative">
          <p>Popularity rate</p>
          <p class="text-[40px] font-semibold">87</p>
        </div>
        <div class="bg-white rounded-xl px-4 py-2 m-4 text-gray-500 text-xs">
          <p>Awesome! It looks like this event is really popular right now!.</p>
        </div>
      </div>

      <div class="flex flex-col gap-3">
        <p class="text-lg font-bold text-gray-600">Change History</p>

        <div class="bg-gray-100 rounded-xl p-4 text-sm">
          <p class="text-gray-600 font-semibold !mb-1">Jun 3, 2025</p>
          <p class="text-gray-500 text-xs"><b>Name:</b> Old name -> New name</p>
          <p class="text-gray-500 text-xs"><b>Host:</b> Old host -> New host</p>
        </div>
        <div class="bg-gray-100 rounded-xl p-4 text-sm">
          <p class="text-gray-600 font-semibold !mb-1">Jun 1, 2025</p>
          <p class="text-gray-500 text-xs"><b>Name:</b> Old name -> New name</p>
          <p class="text-gray-500 text-xs"><b>Host:</b> Old host -> New host</p>
        </div>
        <div class="bg-gray-100 rounded-xl p-4 text-sm">
          <p class="text-gray-600 font-semibold !mb-1">May 26, 2025</p>
          <p class="text-gray-500 text-xs"><b>Name:</b> Old name -> New name</p>
          <p class="text-gray-500 text-xs"><b>Host:</b> Old host -> New host</p>
        </div>
        <div class="bg-gray-100 rounded-xl p-4 text-sm">
          <p class="text-gray-600 font-semibold !mb-1">May 20, 2025</p>
          <p class="text-gray-500 text-xs">Pulled from <b>Google</b></p>
        </div>
      </div>
    </section>
  </div>
</div>